<template>
  <div class='CheckoutSideHead01'
  :style="{
    backgroundColor: Prefes.cart.corBackground,
    color: Prefes.cart.corFont,
    fontFamily: Prefes.cart.font
  }"
  >
    <cart-icon01 :color="Prefes.cart.corFont" :count="false" tam="25px" />
    <div class="label">Carrinho de Compras</div>
    <div class="x" @click="$emit('update:out', true)">X</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CartIcon01 from '../Icons/CartIcon01'
export default {
  name: 'CheckoutSideHead01',
  components: { CartIcon01 },
  props: ['out'],
  emits: ['update:out'],
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.CheckoutSideHead01 {
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: orange;
  border-top-left-radius: 10px;
}

.label {
  width: 40%;
  text-align: left;
  color: #FFFFFF;
  text-wrap: nowrap;
}

.x {
  width: 40%;
  text-align: right;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
